<template>
  <div class="onward-end-date">
    <label class="onward-end-date__toggle">
      <input type="checkbox" :checked="!!enddate" @change="onToggle">
      <span>{{ label }}</span>
    </label>
    <DateSelector
      v-if="enddate"
      :date="enddate"
      :minDate="minDate"
      :width100="true"
      @changed="onDateChanged">
    </DateSelector>
  </div>
</template>

<script>
import DateSelector from '../datepicker/DateSelector'
import moment from 'moment'

export default {
  components: {DateSelector},
  props: {
    enddate: {
      default: null
    },
    minDate: {
      default: null
    },
    label: {
      type: String,
      required: true
    }
  },
  methods: {
    defaultEnddate () {
      return moment(this.minDate || undefined).format('YYYY-MM-DD')
    },
    onToggle (event) {
      this.$emit('update:enddate', event.target.checked ? this.defaultEnddate() : null)
    },
    onDateChanged (date) {
      this.$emit('update:enddate', moment(date).format('YYYY-MM-DD'))
    }
  }
}
</script>

<style scoped>
.onward-end-date {
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.onward-end-date__toggle {
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #555;
  cursor: pointer;
}

.onward-end-date__toggle input {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// OnwardEndDate.vue?29abc094